import React, { useState, useEffect } from 'react';
import Button from "app/components/CustomButtons/Button.js";
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import GridItem from "app/components/Grid/GridItem.js";
import GridContainer from "app/components/Grid/GridContainer.js";
import Autocomplete from '@mui/material/Autocomplete';
import axios from 'axios';
import $ from 'jquery';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { makeStyles } from "@material-ui/core/styles";
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { whiteColor } from 'app/layout/material-dashboard-react';
import CircularProgress from '@mui/material/CircularProgress';
import Snackbar from "app/components/Snackbar/Snackbar.js";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';

const useStyles = makeStyles(() => ({
    paper: { minWidth: "1400px" },
}));

const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&:before': {
        display: 'none',
    },
}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor:
        theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .03)',
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

//React export function used to create the add address function
export default function AddAddress(props) {
    const { buttonColour, sectionColour } = props;

    //Setting the states 
    const [open, setOpen] = React.useState(false);
    const [countries, setCountries] = useState([]);
    const [responseMessage, setResponseMessage] = useState("");
    const [lookupField, setLookUp] = useState([]);
    const [vehiclesize, setVehicleSize] = useState([]);
    const [expanded, setExpanded] = React.useState('panel1');
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);
    const [pendingAddress, setPendingAddress] = useState(false);
    const [postCodeRegex, setPostCodeRegex] = useState([]);
    const classes = useStyles();

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_ENDPOINT}/api/lookup/GetVehicleSize`)
            .then((res) => {
                setVehicleSize(res.data);
            })
            .catch((e) => {
                console.log('error happened');
            });
    }, []);

    useEffect(() => {
        if(countries.length === 0) {
            axios
                .get(`${process.env.REACT_APP_API_ENDPOINT}/api/lookup/GetCountryCodes`)
                .then((res) => {
                    setCountries(res.data);
                })
                .catch((err) => {
                    console.error(`An error occured while fetching countries: ${err}`);
                });
        }
    }, [countries])

    useEffect(() => {
        async function getPostCodeRegex() {
            try {
                await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/api/address/GetPostCodeRegex`)
                    .then((result) =>
                        setPostCodeRegex(result.data));

            } catch (error) {
                console.error(`An error occured while fetching PostCode Regex: ${error}`);
            }
        }
        getPostCodeRegex();

    }, []);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setResponseMessage("");
        setSuccess(false);
        setError(false);
        setOpen(false);
    };

    //On change handle the postcode look up request
    const handlePostcodeLookUp = () => {
        setLookUp([]);
        axios
            .get(`${process.env.REACT_APP_API_ENDPOINT}/api/address/GetPostCodeSearch`, { params: { postcode: $("#postcode").val(), country: $("#country").val() } })
            .then((res) => {
                setLookUp(res.data);
                if (res.data.length === 0) {
                    setError(true);
                    setSuccess(false);
                    setResponseMessage('Unable to find addresses.');
                }
            })
            .catch((e) => {
                setError(true);
                setSuccess(false);
                setResponseMessage('Unable to find addresses.');
            });
    };

    //On click handle the selected address
    const handleSelectedAddress = (target) => {
        var addressArr = target.label.split(',');

        $("#buildingname").val(addressArr[0]);
        $("#buildingnumber").val(addressArr[1]);
        $("#thoroughfare").val(addressArr[2]);
        $("#locality").val(addressArr[3]);
        $("#towncity").val(addressArr[4]);
        $("#countystate").val(addressArr[5]);
        $("#postcode").val(addressArr[6]);
    };

    //function to handle the accordion expandtion
    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    //function to auto populate the opening and closing times 
    const handleChangeOpeningTimes = (panel) => (event, newExpanded) => {

        var mondayOpening = $("#mondayOpeningDate").val();
        var mondayClosing = $("#mondayClosingDate").val();
        $("#tuedayOpeningDate").val(mondayOpening);
        $("#tuesdayClosingDate").val(mondayClosing);
        $("#wednesdayOpeningDate").val(mondayOpening);
        $("#wednesdayClosingDate").val(mondayClosing);
        $("#thursdayOpeningDate").val(mondayOpening);
        $("#thursdayClosingDate").val(mondayClosing);
        $("#fridayOpeningDate").val(mondayOpening);
        $("#fridayClosingDate").val(mondayClosing);
    };

    //function to auto populate the lunch times
    const handleChangeLunchTimes = (panel) => (event, newExpanded) => {

        var mondayLunchStart = $("#mondayLunchStart").val();
        var mondayLunchEnd = $("#mondayLunchEnd").val();
        $("#tuesdayLunchStart").val(mondayLunchStart);
        $("#tuesdayLunchEnd").val(mondayLunchEnd);
        $("#wednesdayLunchStart").val(mondayLunchStart);
        $("#wednesdayLunchEnd").val(mondayLunchEnd);
        $("#thursdayLunchStart").val(mondayLunchStart);
        $("#thursdayLunchEnd").val(mondayLunchEnd);
        $("#fridayLunchStart").val(mondayLunchStart);
        $("#fridayLunchEnd").val(mondayLunchEnd);
    };

    function IsValidPostcode(country, postCode) {
        var countrycode = country.substr(country.length - 2);
        var countryHasRegex = postCodeRegex.find(x => x.countryCode === countrycode);
        if (countryHasRegex) {
            var result = postCodeRegex.some(x => x.countryCode === countrycode && new RegExp(x.regex).test(postCode));
            if (result) {
                return true;
            }
            return false;
        }
        //Country Code doesnt have regex validation so allow the user to add the address.
        return true;
    };

    function validation() {
        setSuccess(false);
        setError(false);

        if (!IsValidPostcode($("#country").val(), $("#postcode").val())) {
            setError(true);
            setSuccess(false);
            setResponseMessage('Postcode mismatch.');
            return false;
        }

        return true;
    }

    //Handle the on submit request to post the new address 
    const onSubmit = (e) => {
        e.preventDefault();

        if (!validation()) {
            return;
        }

        const form = e.currentTarget;
        const formData = new FormData(form);
        const plainFormData = Object.fromEntries(formData.entries());
        const formDataJsonString = JSON.stringify(plainFormData);

        setPendingAddress(true);

        axios
            .post(
                `${process.env.REACT_APP_API_ENDPOINT}/api/address/PostAddress`,
                formDataJsonString
            )
            .then(function (response) {
                if (response.data === "Address added successfully. ") {
                    setResponseMessage(response.data);
                    setSuccess(true);
                    setError(false);
                }
                else {
                    setResponseMessage(response.data);
                    setError(true);
                    setSuccess(false);
                }

                setPendingAddress(false);
            })
            .catch(function (error) {
                console.log(error);
                setError(true);
                setSuccess(false);
                setResponseMessage(error.message);
                setPendingAddress(false);
            });
    };

    //Render the button and dialog form to screen
    return (
        <div>
            <Button color={buttonColour} data-testid="AddAddressButton" onClick={handleClickOpen} style={{ marginTop: 14 }}>
                Add Address
            </Button>
            <Dialog open={open} onClose={handleClose} classes={{ paper: classes.paper }}>
                <form onSubmit={onSubmit}>
                    <DialogTitle>Add Address</DialogTitle>
                    <DialogContent>
                        <Accordion expanded={true} onChange={handleChange('panel1')} style={{ marginTop: '10px' }} >
                            <AccordionSummary data-testid="addAddressInformationAccordion" aria-controls="panel1d-content" id="panel1d-header" style={{ backgroundColor: sectionColour, color: whiteColor }}>
                                <Typography>Address Information</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <GridContainer direction={'row'}>
                                    <GridItem xs={6} style={{ marginTop: "10px" }}>
                                        <GridItem>
                                            <TextField size="small" autoFocus id="organisationname" name="organisationname" label="Organisation name" type="text" InputLabelProps={{ shrink: true }} fullWidth required />
                                        </GridItem>
                                        <GridItem>
                                            <TextField size="small" id="additionalinformation" name="additionalinformation" label="Additional information" type="text" InputLabelProps={{ shrink: true }} fullWidth sx={{ marginTop: 1 }} />
                                        </GridItem>
                                        <GridItem>
                                            <Autocomplete size="small" disablePortal id="country" name="country" options={countries} defaultValue="" sx={{  marginTop: 1 }} renderInput={(params) => <TextField {...params} size="small" label="Country" name="country" id="country" InputLabelProps={{ shrink: true }} required />} />
                                        </GridItem>
                                        <GridItem>
                                            <Autocomplete size="small" disablePortal id="searchfield" name="searchfield" options={lookupField} onInputChange={() => handlePostcodeLookUp()} onChange={(event, value) => handleSelectedAddress(value)} defaultValue="" sx={{ marginTop: 1 }} renderInput={(params) => <TextField size="small" {...params} label="Address Search" InputLabelProps={{ shrink: true }} />} />
                                        </GridItem>
                                        <GridItem>
                                            <TextField size="small" id="buildingnumber" name="buildingnumber" label="Building Number" type="text" InputLabelProps={{ shrink: true }} fullWidth />
                                        </GridItem>
                                        <GridItem>
                                            <TextField size="small" id="buildingname" name="buildingname" label="Building Name" type="text" InputLabelProps={{ shrink: true }} sx={{ marginTop: 1 }} fullWidth />
                                        </GridItem>
                                        <GridItem>
                                            <TextField size="small" id="thoroughfare" name="thoroughfare" label="Address Line 1" InputLabelProps={{ shrink: true }} type="text" sx={{ marginTop: 1 }} fullWidth required />
                                        </GridItem>
                                        <GridItem>
                                            <TextField size="small" id="locality" name="locality" label="Address Line 2" type="text" InputLabelProps={{ shrink: true }} sx={{ marginTop: 1 }} fullWidth />
                                        </GridItem>
                                        <GridItem>
                                            <TextField size="small" id="towncity" name="towncity" label="Town/City" type="text" InputLabelProps={{ shrink: true }} sx={{ marginTop: 1 }} fullWidth required />
                                        </GridItem>
                                        <GridItem>
                                            <TextField size="small" id="countystate" name="countystate" label="County/State" InputLabelProps={{ shrink: true }} type="text" sx={{ marginTop: 1 }} fullWidth required />
                                        </GridItem>
                                        <GridItem>
                                            <TextField size="small" id="postcode" name="postcode" label="Postcode" InputLabelProps={{ shrink: true }} type="text" sx={{ marginTop: 1 }} fullWidth required />
                                        </GridItem>
                                    </GridItem>
                                </GridContainer>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion expanded={expanded === 'panel5'} onChange={handleChange('panel5')} >
                            <AccordionSummary data-testid="addAddressContactsAccordion" aria-controls="panel5d-content" id="panel5d-header" style={{ backgroundColor: sectionColour, color: "#fff" }}>
                                <Typography>Contacts</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <TextField size="small" id="contactName" name="contactName" label="Name" type="text" InputLabelProps={{ shrink: true }} sx={{ marginTop: 1 }} fullWidth />
                                <TextField size="small" id="contactTelephone" name="contactTelephone" label="Telephone" type="text" InputLabelProps={{ shrink: true }} sx={{ marginTop: 1 }} fullWidth />
                                <TextField size="small" id="contactMobile" name="contactMobile" label="Mobile" type="text" InputLabelProps={{ shrink: true }} sx={{ marginTop: 1 }} fullWidth />
                                <TextField size="small" id="contactEmail" name="contactEmail" label="Email" type="text" InputLabelProps={{ shrink: true }} sx={{ marginTop: 1 }} fullWidth />
                            </AccordionDetails>
                        </Accordion>
                        <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                            <AccordionSummary data-testid="addAddressOpeningTimesAccordion" aria-controls="panel3d-content" id="panel3d-header" style={{ backgroundColor: sectionColour, color: "#fff" }}>
                                <Typography>Opening Times</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <TableContainer component={Paper}>
                                    <Table sx={{ Width: 650 }} size="small" aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Day</TableCell>
                                                <TableCell align="right">Closed</TableCell>
                                                <TableCell align="right">Opening Time</TableCell>
                                                <TableCell align="right">Closing Time</TableCell>
                                                <TableCell align="right">Lunch Start</TableCell>
                                                <TableCell align="right">Lunch End</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell component="th" scope="row">Monday</TableCell>
                                                <TableCell align="right"><Checkbox name="cbMonday" id="cbMonday" /></TableCell>
                                                <TableCell align="right"><TextField id="mondayOpeningDate" name="mondayOpeningDate" size="small" InputLabelProps={{ shrink: true, required: true }} type="time" /></TableCell>
                                                <TableCell align="right"><TextField id="mondayClosingDate" name="mondayClosingDate" size="small" InputLabelProps={{ shrink: true, required: true }} type="time" onChange={handleChangeOpeningTimes()} /></TableCell>
                                                <TableCell align="right"><TextField id="mondayLunchStart" name="mondayLunchStart" size="small" InputLabelProps={{ shrink: true, required: true }} type="time" /></TableCell>
                                                <TableCell align="right"><TextField id="mondayLunchEnd" name="mondayLunchEnd" size="small" InputLabelProps={{ shrink: true, required: true }} type="time" onChange={handleChangeLunchTimes()} /></TableCell>
                                            </TableRow>
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell component="th" scope="row">Tuesday</TableCell>
                                                <TableCell align="right"><Checkbox name="cbTuesday" id="cbTuesday" /></TableCell>
                                                <TableCell align="right"><TextField id="tuedayOpeningDate" name="tuedayOpeningDate" size="small" InputLabelProps={{ shrink: true, required: true }} type="time" /></TableCell>
                                                <TableCell align="right"><TextField id="tuesdayClosingDate" name="tuesdayClosingDate" size="small" InputLabelProps={{ shrink: true, required: true }} type="time" /></TableCell>
                                                <TableCell align="right"><TextField id="tuesdayLunchStart" name="tuesdayLunchStart" size="small" InputLabelProps={{ shrink: true, required: true }} type="time" /></TableCell>
                                                <TableCell align="right"><TextField id="tuesdayLunchEnd" name="tuesdayLunchEnd" size="small" InputLabelProps={{ shrink: true, required: true }} type="time" /></TableCell>
                                            </TableRow>
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell component="th" scope="row">Wednesday</TableCell>
                                                <TableCell align="right"><Checkbox name="cbWednesday" id="cbWednesday" /></TableCell>
                                                <TableCell align="right"><TextField id="wednesdayOpeningDate" name="wednesdayOpeningDate" size="small" InputLabelProps={{ shrink: true, required: true }} type="time" /></TableCell>
                                                <TableCell align="right"><TextField id="wednesdayClosingDate" name="wednesdayClosingDate" size="small" InputLabelProps={{ shrink: true, required: true }} type="time" /></TableCell>
                                                <TableCell align="right"><TextField id="wednesdayLunchStart" name="wednesdayLunchStart" size="small" InputLabelProps={{ shrink: true, required: true }} type="time" /></TableCell>
                                                <TableCell align="right"><TextField id="wednesdayLunchEnd" name="wednesdayLunchEnd" size="small" InputLabelProps={{ shrink: true, required: true }} type="time" /></TableCell>
                                            </TableRow>
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell component="th" scope="row">Thursday</TableCell>
                                                <TableCell align="right"><Checkbox name="cbThursday" id="cbThursday" /></TableCell>
                                                <TableCell align="right"><TextField id="thursdayOpeningDate" name="thursdayOpeningDate" size="small" InputLabelProps={{ shrink: true, required: true }} type="time" /></TableCell>
                                                <TableCell align="right"><TextField id="thursdayClosingDate" name="thursdayClosingDate" size="small" InputLabelProps={{ shrink: true, required: true }} type="time" /></TableCell>
                                                <TableCell align="right"><TextField id="thursdayLunchStart" name="thursdayLunchStart" size="small" InputLabelProps={{ shrink: true, required: true }} type="time" /></TableCell>
                                                <TableCell align="right"><TextField id="thursdayLunchEnd" name="thursdayLunchEnd" size="small" InputLabelProps={{ shrink: true, required: true }} type="time" /></TableCell>
                                            </TableRow>
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell component="th" scope="row">Friday</TableCell>
                                                <TableCell align="right"><Checkbox name="cbFriday" id="cbFriday" /></TableCell>
                                                <TableCell align="right"><TextField id="fridayOpeningDate" name="fridayOpeningDate" size="small" InputLabelProps={{ shrink: true, required: true }} type="time" /></TableCell>
                                                <TableCell align="right"><TextField id="fridayClosingDate" name="fridayClosingDate" size="small" InputLabelProps={{ shrink: true, required: true }} type="time" /></TableCell>
                                                <TableCell align="right"><TextField id="fridayLunchStart" name="fridayLunchStart" size="small" InputLabelProps={{ shrink: true, required: true }} type="time" /></TableCell>
                                                <TableCell align="right"><TextField id="fridayLunchEnd" name="fridayLunchEnd" size="small" InputLabelProps={{ shrink: true, required: true }} type="time" /></TableCell>
                                            </TableRow>
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell component="th" scope="row">Saturday</TableCell>
                                                <TableCell align="right"><Checkbox name="cbSaturday" id="cbSaturday" /></TableCell>
                                                <TableCell align="right"><TextField id="saturdayOpeningDate" name="saturdayOpeningDate" size="small" InputLabelProps={{ shrink: true, required: true }} type="time" /></TableCell>
                                                <TableCell align="right"><TextField id="saturdayClosingDate" name="saturdayClosingDate" size="small" InputLabelProps={{ shrink: true, required: true }} type="time" /></TableCell>
                                                <TableCell align="right"><TextField id="saturdayLunchStart" name="saturdayLunchStart" size="small" InputLabelProps={{ shrink: true, required: true }} type="time" /></TableCell>
                                                <TableCell align="right"><TextField id="saturdayLunchEnd" name="saturdayLunchEnd" size="small" InputLabelProps={{ shrink: true, required: true }} type="time" /></TableCell>
                                            </TableRow>
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell component="th" scope="row">Sunday</TableCell>
                                                <TableCell align="right"><Checkbox name="cbSunday" id="cbSunday" /></TableCell>
                                                <TableCell align="right"><TextField id="sundayOpeningDate" name="sundayOpeningDate" size="small" InputLabelProps={{ shrink: true, required: true }} type="time" /></TableCell>
                                                <TableCell align="right"><TextField id="sundayClosingDate" name="sundayClosingDate" size="small" InputLabelProps={{ shrink: true, required: true }} type="time" /></TableCell>
                                                <TableCell align="right"><TextField id="sundayLunchStart" name="sundayLunchStart" size="small" InputLabelProps={{ shrink: true, required: true }} type="time" /></TableCell>
                                                <TableCell align="right"><TextField id="sundayLunchEnd" name="sundayLunchEnd" size="small" InputLabelProps={{ shrink: true, required: true }} type="time" /></TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')} >
                            <AccordionSummary data-testid="addAddressDeliveryInformationAccordion" aria-controls="panel2d-content" id="panel2d-header" style={{ backgroundColor: sectionColour, color: "#fff" }}>
                                <Typography>Delivery Information</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <TextField size="small" id="collectioninstructions" name="collectioninstructions" label="Collection Instructions" type="text" InputLabelProps={{ shrink: true }} sx={{ marginTop: 3 }} multiline rows={6} fullWidth />
                                <TextField size="small" id="deliveryinstructions" name="deliveryinstructions" label="Delivery Instructions" type="text" InputLabelProps={{ shrink: true }} sx={{ marginTop: 3}} multiline rows={6} fullWidth />
                            </AccordionDetails>
                        </Accordion>
                        <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')} >
                            <AccordionSummary data-testid="addAddressVehicleInformationAccordion" aria-controls="panel2d-content" id="panel2d-header" style={{ backgroundColor: sectionColour, color: "#fff" }}>
                                <Typography>Vehicle Information</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <GridContainer direction={'row'}>
                                    <GridItem xs={12}>
                                        <Autocomplete size="small" disablePortal id="vehicleSize" named="vehicleSize" options={vehiclesize} sx={{ marginTop: 1, marginBottom: 2 }} renderInput={(params) => <TextField {...params} label="Vehicle Size" />} />
                                    </GridItem>
                                    <GridItem xs={12}>
                                        <GridContainer direction={'row'}>
                                            <GridItem>
                                                <FormControl component="fieldset">
                                                    <FormLabel component="legend">Box Vehicle</FormLabel>
                                                    <RadioGroup row aria-label="BoxVehicle" name="row-radio-buttons-group">
                                                        <FormControlLabel value="Mandatory" control={<Radio name="cbBoxMandatory" id="cbBoxMandatory" />} label="Mandatory" />
                                                        <FormControlLabel value="Permitted" control={<Radio name="cbBoxPermitted" id="cbBoxPermitted" />} label="Permitted" />
                                                        <FormControlLabel value="NotPermitted" control={<Radio name="cbBoxNotPermitted" id="cbBoxNotPermitted" />} label="Not Permitted" />
                                                    </RadioGroup>
                                                </FormControl>
                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer direction={'row'}>
                                            <GridItem>
                                                <FormControl component="fieldset">
                                                    <FormLabel component="legend">Side Loading Vehicle</FormLabel>
                                                    <RadioGroup row aria-label="SideLoadingVehicle" name="row-radio-buttons-group">
                                                        <FormControlLabel value="Mandatory" control={<Radio name="cbSideLoadingMandatory" id="cSideLoadingMandatory" />} label="Mandatory" />
                                                        <FormControlLabel value="Permitted" control={<Radio name="cbSideLoadingPermitted" id="cbSideLoadingPermitted" />} label="Permitted" />
                                                        <FormControlLabel value="NotPermitted" control={<Radio name="cbSideLoadingNotPermitted" id="cbSideLoadingNotPermitted" />} label="Not Permitted" />
                                                    </RadioGroup>
                                                </FormControl>
                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer direction={'row'}>
                                            <GridItem>
                                                <FormControl component="fieldset">
                                                    <FormLabel component="legend">Tail Lift</FormLabel>
                                                    <RadioGroup row aria-label="SideLoadingVehicle" name="row-radio-buttons-group">
                                                        <FormControlLabel value="Taillift" control={<Radio name="cbTailliftrequired" id="cbTailliftrequired" />} label="Tail lift vehicle required" />
                                                        <FormControlLabel value="Cantilever" control={<Radio name="cbCantilevertailliftrequired" id="cbCantilevertailliftrequired" />} label="Cantilever tail lift" />
                                                        <FormControlLabel value="Foldunder" control={<Radio name="cbFoldundertailliftrequired" id="cbFoldundertailliftrequired" />} label="Fold under tail lift" />
                                                    </RadioGroup>
                                                </FormControl>
                                            </GridItem>
                                        </GridContainer>
                                    </GridItem>
                                </GridContainer>
                            </AccordionDetails>
                        </Accordion>
                        {success && <div style={{ color: "green" }}>{responseMessage}</div>}
                        {error && <div style={{ color: "red" }}>{responseMessage}</div>}
                        <Button color={buttonColour} data-testid="addAddressCloseButton" onClick={handleClose} style={{ float: "right" }}>Close</Button>
                        <Button color={buttonColour} data-testid="addAddressSaveButton" type="submit" disabled={pendingAddress || success} style={{ float: "right" }}>Save</Button>
                        {pendingAddress && (<CircularProgress style={{ position: 'absolute', marginTop: 5, marginLeft: 1163, color: '#FFF' }}></CircularProgress>)}
                    </DialogContent>
                </form>
            </Dialog>
        </div>
    );
}